import image2 from '../../assets/programs/future_changemakers/image2.webp'
import image3 from '../../assets/programs/future_changemakers/image3.webp'
import image4 from '../../assets/programs/future_changemakers/image4.webp'
import image5 from '../../assets/programs/future_changemakers/image5.webp'
import image6 from '../../assets/programs/future_changemakers/image6.webp'

const grip_data = {
    "title": "Changemakers",
    "description": "Changemakers: Summer Bootcamp at IIT Delhi is an immersive program focusing on STEM and Humanities through hands-on learning and problem-solving. It combines academic enrichment with fun-filled trips and social activities, providing a balanced, well-rounded experience. The program is conducted by IIT Delhi's faculty, students, and alumni",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image2,
                            "desc": ""
                        },
                        {
                            "src": image3,
                            "desc": ""
                        },
                        {
                            "src": image4,
                            "desc": ""
                        },
                        {
                            "src": image5,
                            "desc": ""
                        },
                        {
                            "src": image6,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default grip_data;